import { render, staticRenderFns } from "./ChatToolIndicator.vue?vue&type=template&id=3951afbe&scoped=true&"
import script from "./ChatToolIndicator.vue?vue&type=script&lang=js&"
export * from "./ChatToolIndicator.vue?vue&type=script&lang=js&"
import style0 from "./ChatToolIndicator.vue?vue&type=style&index=0&id=3951afbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3951afbe",
  null
  
)

export default component.exports